import { SubSection } from "./fundCardHelpers";
import { InfoRow } from "../UI";

export default function EmployerTab({ fund, cs }) {
  if (!fund.employer) return null;
  const emp = fund.employer;
  // מעסיקים נוספים/קודמים בפוליסה (מעבר למעסיק הנוכחי המוצג למעלה)
  const others = (fund.employers || []).filter(e => !e.isCurrent);

  return (
    <>
      <SubSection title="מעסיק" color={cs.accent}>
        <InfoRow
          label="שם מעסיק"
          value={emp.name && (
            <span>
              {emp.name}
              {emp.statusLabel && (
                <span style={{
                  marginRight: 8, padding: "2px 8px", borderRadius: 12,
                  fontSize: 10, fontWeight: 700,
                  background: emp.status === "1" ? "#dcfce7" : "#f1f5f9",
                  color: emp.status === "1" ? "#166534" : "#475569",
                  border: `1px solid ${emp.status === "1" ? "#16a34a" : "#94a3b8"}30`,
                }}>
                  {emp.statusLabel}
                </span>
              )}
            </span>
          )}
          bold
        />
        <InfoRow label="ח.פ מעסיק" value={emp.id} />
        <InfoRow label="עיר מעסיק" value={emp.city} />
        <InfoRow label="טלפון מעסיק" value={emp.phone} />
        <InfoRow label="תחילת תשלום" value={emp.startDate} />
        <InfoRow label="הפקדה אחרונה" value={emp.lastDepositDate} />
      </SubSection>

      {others.length > 0 && (
        <SubSection title={`מעסיקים קודמים / נוספים (${others.length})`} color={cs.accent}>
          {others.map((e, i) => (
            <div key={i} style={{
              marginBottom: 8, padding: "8px 12px", background: "#f8fafc",
              borderRadius: 8, border: "1px solid #e2e8f0",
            }}>
              <div style={{ fontWeight: 600, fontSize: 13, color: "#334155", marginBottom: 2 }}>
                {e.name || "מעסיק ללא שם"}
                {e.statusLabel && (
                  <span style={{ marginRight: 8, fontSize: 10, fontWeight: 700, color: "#64748b" }}>
                    ({e.statusLabel})
                  </span>
                )}
              </div>
              <div style={{ display: "flex", gap: 16, flexWrap: "wrap", fontSize: 11, color: "#64748b" }}>
                {e.id && <span>ח.פ: {e.id}</span>}
                {e.startDate && <span>תחילת תשלום: {e.startDate}</span>}
                {e.lastDepositDate && <span>הפקדה אחרונה: {e.lastDepositDate}</span>}
              </div>
            </div>
          ))}
        </SubSection>
      )}
    </>
  );
}
